import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CartOrdersModuleGeneric, OrdersCheckoutLayoutModuleGeneric } from '@signature-it/ngx-catalogue/components/cart/orders';
import { CartContinueActionsGenericModule } from '@signature-it/ngx-catalogue/components/cart-continue-actions';
import { MainHeaderCartComponentGeneric } from './cart.component';
import { CartSummaryModuleGeneric } from '@signature-it/ngx-catalogue/components/cart/summary';
import { createCustomElement } from "@angular/elements";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        PopoverModule.forRoot(),
        CartOrdersModuleGeneric,
        CartContinueActionsGenericModule,
        CartSummaryModuleGeneric,
        OrdersCheckoutLayoutModuleGeneric
    ],
    declarations: [MainHeaderCartComponentGeneric],
    exports: [MainHeaderCartComponentGeneric]
})
export class MainHeaderCartModuleGeneric {
    constructor(private injector: Injector) {
        const mainHeaderCart = createCustomElement(MainHeaderCartComponentGeneric, {injector});
        !customElements.get('ngx-main-header-cart') && customElements.define('ngx-main-header-cart', mainHeaderCart);
    }
}
